import React, { useEffect, useState, useRef } from "react";
import { Grid, makeStyles, IconButton } from "@material-ui/core";
import { Box as MuiBox } from "@mui/material";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { styled } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { get, filter, map, head, clone } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { showError, showSuccess } from "../../v2_actions/error";
import { PhotographUploader } from "../form/PhotographUploader";
import {
  DEFAULT_NUM_TEMS_PER_GALLERY_PAGE,
  galleryList,
} from "../../v2_actions/gallery";
import moment from "moment";
import { LocationSelector } from "../form/LocationSelector";
import { confirmModal } from "../../v2_actions/ui";
import { useForm } from "react-hook-form";
import { GalleryPriceSelector } from "../form/GalleryPriceSelector";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {
  activityTagDropdownOptions,
  galleryEventDropdownOptions,
} from "../../v2_actions/dropdown_options";
import { getUserStoredCountry } from "v2_actions/auth_country";
import { GalleryEditor } from "../GalleryEditorSideBar";
import { processGalleryPhotographsProgressList } from "v2_actions/process_gallery_photographs_progress";

const useStyles = makeStyles(styles);

const PROCESS_GALLERY_PHOTOGRAPHS_PROGRESS_INTERVAL_IN_MILLISECONDS = 30000;

const MenuClass = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 250,
    },
  },
  BlueBtn: {
    background: "#75A9F9",
  },
};
const Box = styled(MuiBox)({
  width: "100%",
  display: "flex",
  gap: "8px",
});

export const GallerySideBar = ({
  gallery_id,
  country_code,
  getGallerySpecificActions,
  hideViewSideBarForPhotoArt,
}) => {
  let selectedGallery;
  const classes = useStyles();
  const dispatch = useDispatch();
  const processGalleryPhotographsProgressIntervalRef = useRef(null);
  const [showMap, setShowMap] = useState(true);
  const [galleryIdIntervalInFocus, setGalleryIdIntervalInFocus] =
    useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [eventGallery, setEventGallery] = useState(null);
  const [activityTags, setActivityTags] = useState([]);
  const galleryEventOptions = useSelector(() =>
    galleryEventDropdownOptions.getAsOptions(),
  );
  const [galleryType, setGalleryType] = useState("");
  const history = useHistory();
  const processGalleryPhotograph = head(
    useSelector(() =>
      processGalleryPhotographsProgressList.getVisibleObjects(),
    ),
  );

  const [sessionNameVal, setSessionNameVal] = useState("");
  const [openSports, setOpenSports] = useState(false);
  const galleries = useSelector(() => galleryList.getVisibleObjects());
  const [fileUploadsInProgress, setFileUploadsInProgress] = useState({});
  const galleries_excluding_photoart = filter(
    galleries,
    (gallery) => gallery.gallery_type !== "photo_art",
  );
  const gallery = useSelector(() => galleryList.getObject(gallery_id));

  function format(x) {
    return Number.parseFloat(x).toFixed(2);
  }

  const activityTagOptions = useSelector(() =>
    activityTagDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "activity",
    }),
  );
  let activity_tag_options = activityTagOptions.filter(
    (val) => val.value !== "any",
  );

  const defaultValues = {
    shot_at_date: new Date(),
    shot_at_time: moment(new Date()).set({ hour: 14, minute: 0 }).toDate(),
    lat: null,
    lng: null,
    time_duration_hours: "2",
    session_name: null,
    description: gallery.description || "",
    activityTags: [],
    genre_tags: null,
    gallery_event: null,
    available_to_purchase: get(gallery, "available_to_purchase", null),
    gallery_type: get(gallery, "gallery_type", null),
    gallery_password: null,
    gallery_price: {
      base_price: null,
      low_res_price: null,
      discount1_percentage: null,
      discount2_percentage: null,
      discount3_percentage: null,
      discount4_percentage: null,
    },
  };

  selectedGallery = useSelector((state) => state.gallery.selectedGallery);
  if (gallery_id) {
    selectedGallery = gallery;
  }
  const selectedGalleryLowResPrice = get(selectedGallery, [
    "gallery_price",
    "low_res_price",
  ]);
  const selectedGalleryLowResPriceExists = selectedGalleryLowResPrice !== null;
  const numberOfPhotographsIndexedForFRInSelectedGallery = get(
    selectedGallery,
    "number_of_gallery_photographs_indexed_for_facial_recognition",
  );
  const numberOfPhotosInSelectedGallery = get(
    selectedGallery,
    "number_of_photos_in_gallery",
  );

  const isPhotoArt =
    get(selectedGallery, "gallery_type") === "photo_art" ? true : false;
  const editGalleryAble = useSelector((state) => state.gallery.editGalleryAble);

  const galleryPriceDiscountBands = [
    {
      band: "2-5",
      discount: get(selectedGallery, ["gallery_price", "discount1_percentage"]),
    },
    {
      band: "6-10",
      discount: get(selectedGallery, ["gallery_price", "discount2_percentage"]),
    },
    {
      band: "11-50",
      discount: get(selectedGallery, ["gallery_price", "discount3_percentage"]),
    },
    {
      band: "50+",
      discount: get(selectedGallery, ["gallery_price", "discount4_percentage"]),
    },
  ];

  useEffect(() => {
    dispatch(
      galleryList.updatePaginationNumItemsPerPage(
        DEFAULT_NUM_TEMS_PER_GALLERY_PAGE,
      ),
    );
    dispatch(galleryList.fetchListIfNeeded());
  }, []);

  useEffect(() => {
    if (!gallery.id) {
      return;
    }
    const values = Object.assign({}, defaultValues, gallery);
    if (!values.gallery_price) {
      values.gallery_price = clone(defaultValues.gallery_price);
    }
    values.shot_at_date = moment(values.shot_at_datetime).toDate();
    values.shot_at_time = moment(values.shot_at_datetime).toDate();
    reset(values);
  }, [gallery.id]);

  useEffect(() => {
    if (gallery.activity_tags) {
      if (activity_tag_options.length > 0) {
        let old_activity_tags = [];
        gallery.activity_tags.map((activity_tag) => {
          let obj = activity_tag_options.filter(
            (activity_tag_option) => activity_tag_option.value === activity_tag,
          );
          if (obj) {
            old_activity_tags.push(obj[0].original_item);
          } else {
            return;
          }
        });
        if (JSON.stringify(activityTags) != JSON.stringify(old_activity_tags)) {
          setActivityTags(old_activity_tags);
        }
      }
    }
  }, [gallery.activity_tags, activity_tag_options, gallery]);

  useEffect(() => {
    dispatch(galleryList.ensureObjectLoaded(gallery_id));
  }, [gallery_id]);

  useEffect(() => {
    if (gallery.activity_tags) {
      if (activity_tag_options.length > 0) {
        let old_activity_tags = [];
        gallery.activity_tags.map((activity_tag) => {
          let obj = activity_tag_options.filter(
            (activity_tag_option) => activity_tag_option.value === activity_tag,
          );
          if (obj) {
            old_activity_tags.push(obj[0].original_item);
          } else {
            return;
          }
        });
        if (JSON.stringify(activityTags) != JSON.stringify(old_activity_tags)) {
          setActivityTags(old_activity_tags);
        }
      }
    }
  }, [gallery.activity_tags, activity_tag_options, gallery]);

  useEffect(() => {
    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
  }, []);

  useEffect(() => {
    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
  }, [gallery_id]);

  useEffect(() => {
    if (selectedGallery && selectedGallery.id) {
      dispatch(processGalleryPhotographsProgressList.invalidateList());
      dispatch(
        processGalleryPhotographsProgressList.processGalleryPhotographsProgress(
          get(selectedGallery, "id"),
        ),
      );
    }
  }, [selectedGallery]);

  useEffect(() => {
    if (processGalleryPhotographsProgressIntervalRef.current) {
      clearInterval(processGalleryPhotographsProgressIntervalRef.current);
    }
    handleProcessGalleryPhotographsProgress();

    if (selectedGallery && selectedGallery.id) {
      processGalleryPhotographsProgressIntervalRef.current = setInterval(() => {
        handleProcessGalleryPhotographsProgress();
      }, PROCESS_GALLERY_PHOTOGRAPHS_PROGRESS_INTERVAL_IN_MILLISECONDS);
    }
    return () => {
      if (processGalleryPhotographsProgressIntervalRef.current) {
        clearInterval(processGalleryPhotographsProgressIntervalRef.current);
      }
    };
  }, [selectedGallery, dispatch]);

  const handleProcessGalleryPhotographsProgress = () => {
    if (selectedGallery && selectedGallery.id) {
      dispatch(processGalleryPhotographsProgressList.invalidateList());
      dispatch(
        processGalleryPhotographsProgressList.processGalleryPhotographsProgress(
          get(selectedGallery, "id"),
        ),
      );
    }
  };

  const onUploadNewGallery = () => {
    history.push(`/photographer/gallery/`);
  };

  const handleActivityTagChange = (event) =>
    setActivityTags(event.target.value);
  const goToPhotoArtGallery = () => {
    history.push(`/photographer/photo_art_gallery`);
  };
  const onEditGallery = (gallery_id) => {
    history.push(`/photographer/gallery/${gallery_id}`);
  };
  const onSelectNewGallery = (gallery_id) => {
    history.push(`/photographer/gallery/${gallery_id}/view`);
  };

  const onViewSelectedGallery = () => {
    if (gallery_id) {
      history.push(`/photographer/gallery/${gallery_id}/view`);
    }
  };

  const onViewMap = () => {
    if (gallery_id) {
      history.push(`/photographer/gallery/${gallery_id}/map`);
    } else {
      history.push(`/photographer/map`);
    }
  };

  const onEditSelectedGallery = () => {
    if (gallery_id) {
      history.push(`/photographer/gallery/${gallery_id}`);
    } else {
      showError("Please select a gallery");
    }
  };

  const onDeleteSelectedGallery = () => {
    const onDeleted = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        history.push("/photographer/map");
        showSuccess("Removed", "Gallery removed");
      }
    };

    const onConfirmed = () => {
      const values = Object.assign({}, gallery, {
        available_to_purchase: false,
      });
      dispatch(galleryList.saveObject(values)).then(onDeleted);
    };

    dispatch(
      confirmModal({
        text: "Are you sure you want to make this gallery unavailable to purchase?",
        onConfirmed: onConfirmed,
        can_cancel: true,
      }),
    );
  };

  const formProps = useForm({});
  const galleryDetails = selectedGallery?.gallery_name?.split(", ") || [];
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = formProps;

  const renderLocationSelector = () => (
    <LocationSelector formProps={formProps} />
  );

  const renderPriceSelector = () => (
    <GalleryPriceSelector
      formProps={formProps}
      gallery_id={gallery_id}
      gallery={gallery}
      gallery_type={galleryType}
      field_name_prefix="gallery_price"
    />
  );

  const renderPhotoUploader = () => (
    <PhotographUploader
      fileAnnotations={fileUploadsInProgress}
      maxFileLimit={getValues("gallery_type") === "photo_art" ? 1 : null}
      onChange={({ files }) =>
        setValue("files", files, { shouldValidate: true })
      }
    />
  );

  const onCancel = () => {
    if (gallery_id && galleryType !== "photo_art") {
      history.push(`/photographer/gallery/${gallery_id}/view`);
    } else if (gallery_id && galleryType === "photo_art") {
      history.push("/photographer/photo_art_gallery");
    } else {
      history.push(`/photographer/map`);
    }
  };

  const renderSubmitButton = () => {
    return (
      <div className={classes.submitAndCancelBtn}>
        {gallery_id ? (
          <Button className={classes.largeBlueBtn} type="submit">
            Update and Submit
          </Button>
        ) : (
          renderSubmitPhotoBtn()
        )}
        <Button className={classes.largeGrayBtn} onClick={onCancel}>
          Cancel
        </Button>
      </div>
    );
  };

  const okToSubmit =
    getValues("session_name") &&
    getValues("lat") &&
    getValues("gallery_price.base_price") &&
    getValues("files");

  const okToSubmitPhotoArt =
    getValues("session_name") &&
    getValues("description") &&
    getValues("genre_tags") &&
    getValues("gallery_price.base_price") &&
    getValues("files");

  const renderSubmitPhotoBtn = () => {
    return (
      <>
        {!okToSubmit && (
          <Button disabled className={classes.largeGrayBtn} type="submit">
            Submit Photo/s
          </Button>
        )}
        {okToSubmit && getValues("gallery_type") !== "photo_art" && (
          <Button className={classes.largeBlueBtn} type="submit">
            Submit Photo/s
          </Button>
        )}
        {okToSubmitPhotoArt && getValues("gallery_type") === "photo_art" && (
          <Button className={classes.largeBlueBtn} type="submit">
            Submit Photo
          </Button>
        )}
      </>
    );
  };

  const renderGeneralSection = () => {
    const onCancel = () => {
      if (gallery_id && galleryType !== "photo_art") {
        history.push(`/photographer/gallery/${gallery_id}/view`);
      } else if (gallery_id && galleryType === "photo_art") {
        history.push("/photographer/photo_art_gallery");
      } else {
        history.push(`/photographer/map`);
      }
    };

    const renderPricingDetailsInCurrencyName = (value) => {
      const photographerCountryCurrencyName = get(
        getUserStoredCountry(),
        "currency_name",
      );
      return (
        photographerCountryCurrencyName && (
          <>
            {value} &nbsp;
            <span className={classes.currencyName}>
              {photographerCountryCurrencyName}
            </span>
          </>
        )
      );
    };

    const renderProcessGalleryPhotographsProgress = () => {
      return get(processGalleryPhotograph, "progress");
    };

    const renderLocationLatAndLng = () => {
      const lat =
        selectedGallery?.lat > 0
          ? `${format(selectedGallery?.lat)}E`
          : `${format(Math.abs(selectedGallery?.lat))}W`;
      const lng =
        selectedGallery?.lng > 0
          ? `${format(selectedGallery?.lng)}N`
          : `${format(Math.abs(selectedGallery?.lng))}S`;
      return `${lat} ${lng}`;
    };

    const renderFieldLabelAndValue = (fieldLabel, fieldValue) => (
      <Grid container xs={12} className={classes.fieldLabelAndValueWrapper}>
        <Grid xs={6}>
          <Typography
            variant="subtitle1"
            className={classes.eventCommissionSplitSubMenuKey}
          >
            {fieldLabel}
          </Typography>
        </Grid>
        <Grid xs={6}>
          <Typography variant="subtitle1" className={classes.subMenu4}>
            {fieldValue}
          </Typography>
        </Grid>
      </Grid>
    );

    return (
      <>
        {!editGalleryAble && (
          <Grid container spacing={0.5} className={classes.rightSideBarWrapper}>
            <Grid item xs={12}>
              <div className={classes.sidebarHeading}>
                {selectedGallery?.gallery_name}
              </div>
            </Grid>
            <span className={classes.gallerySideBarFieldWrapper}>
              <Typography
                variant="subtitle1"
                className={`${classes.subMenu} ${classes.gallerySubMenuHeading}`}
              >
                {isPhotoArt ? "Photo Details" : "Gallery Details"}
              </Typography>
              {renderFieldLabelAndValue(
                "Name",
                isPhotoArt
                  ? get(selectedGallery, "session_name")
                  : galleryDetails[1],
              )}
              {renderFieldLabelAndValue(
                "Date",
                galleryDetails[0]?.split(".")[0],
              )}
              {renderFieldLabelAndValue(
                "Time",
                galleryDetails[0]?.split(".")[1],
              )}
              {renderFieldLabelAndValue(
                "Activity",
                get(selectedGallery, "activity_tag_names"),
              )}
              {renderFieldLabelAndValue("Location", renderLocationLatAndLng())}
              {!isPhotoArt && (
                <>
                  {renderFieldLabelAndValue(
                    "Processed",
                    renderProcessGalleryPhotographsProgress(),
                  )}
                  <Typography
                    variant="subtitle1"
                    className={`${classes.subMenu} ${classes.gallerySubMenuHeading}`}
                  >
                    Event Details
                  </Typography>
                  {renderFieldLabelAndValue(
                    "Event Body/School",
                    get(selectedGallery, "gallery_event_name"),
                  )}
                  {renderFieldLabelAndValue(
                    "Album/Event",
                    get(selectedGallery, "album_name"),
                  )}
                  {renderFieldLabelAndValue(
                    "Facial recognition applied",
                    <Typography
                      variant="subtitle1"
                      className={classes.subMenu4}
                    >
                      {get(selectedGallery, "can_index_for_facial_recognition")
                        ? `${numberOfPhotographsIndexedForFRInSelectedGallery} of ${numberOfPhotosInSelectedGallery}`
                        : "Not active"}
                    </Typography>,
                  )}
                  {renderFieldLabelAndValue(
                    "Password",
                    <Typography
                      variant="subtitle1"
                      className={`${classes.subMenu4}
                     ${classes.gallerySubMenuValue}
                     ${classes.galleryPasswordWrapper}`}
                    >
                      <input
                        className={classes.galleryPassword}
                        type={showPassword ? "text" : "password"}
                        value={get(selectedGallery, "gallery_password") || ""}
                      />
                      {get(selectedGallery, "gallery_password") && (
                        <IconButton
                          className={classes.galleryPasswordVisibilityToggle}
                          onClick={(e) => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      )}
                    </Typography>,
                  )}
                </>
              )}
              <Typography
                variant="subtitle1"
                className={`${classes.subMenu} ${classes.gallerySubMenuHeading}`}
              >
                Pricing Details
              </Typography>
              {renderFieldLabelAndValue(
                "Event Commission Split",
                `${selectedGallery?.gallery_price?.event_commission_percentage} %`,
              )}
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  className={`${classes.subMenu} ${classes.gallerySubMenuKey}`}
                >
                  Price:
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.priceSubMenu}>
                {selectedGalleryLowResPriceExists &&
                  renderFieldLabelAndValue(
                    "Low Res Digital",
                    renderPricingDetailsInCurrencyName(
                      selectedGalleryLowResPrice,
                    ),
                  )}
                {renderFieldLabelAndValue(
                  "High Res Digital",
                  renderPricingDetailsInCurrencyName(
                    selectedGallery?.gallery_price?.base_price,
                  ),
                )}
                {renderFieldLabelAndValue(
                  "Print Only License",
                  renderPricingDetailsInCurrencyName(
                    selectedGallery?.gallery_price?.base_price,
                  ),
                )}
              </Grid>
              {!isPhotoArt && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={`${classes.subMenu} ${classes.gallerySubMenuKey}`}
                    >
                      Discounts:
                    </Typography>
                  </Grid>
                  {map(
                    galleryPriceDiscountBands,
                    (galleryPriceDiscountBand, index) => (
                      <Grid item xs={12}>
                        <Box pl={2}>
                          {renderFieldLabelAndValue(
                            `Photos ${galleryPriceDiscountBand.band}`,
                            galleryPriceDiscountBand.discount,
                          )}
                        </Box>
                      </Grid>
                    ),
                  )}
                </>
              )}
              {isPhotoArt && (
                <>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={`${classes.subMenu} ${classes.gallerySubMenuHeading}`}
                    >
                      Settings
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Box className={classes.box}>
                      <Typography
                        variant="subtitle1"
                        className={`${classes.subMenu} ${classes.gallerySubMenuKey}`}
                      >
                        Printing/Framing Mark Up:{" "}
                        <span className={classes.subMenu4}>50%</span>
                      </Typography>
                    </Box>
                  </Grid>
                  <div className={classes.photoArtImgWrapper}>
                    <img
                      className={classes.photoArtImg}
                      src={get(selectedGallery, "gallery_photo_url")}
                    />
                  </div>
                </>
              )}
            </span>
          </Grid>
        )}
        {editGalleryAble && <GalleryEditor />}
      </>
    );
  };

  return <>{renderGeneralSection()}</>;
};
